import React from 'react'
import { withIcon } from '../../withIcon'

function SlideLastOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.0669 11.1831C14.311 11.4272 14.311 11.8229 14.0669 12.067L8.06694 18.067C7.88819 18.2457 7.61937 18.2992 7.38582 18.2024C7.15228 18.1057 7 17.8778 7 17.625L7 5.62502C7 5.37223 7.15228 5.14433 7.38582 5.04759C7.61937 4.95086 7.88819 5.00433 8.06694 5.18308L14.0669 11.1831ZM8.25 7.1339V16.1161L12.7411 11.625L8.25 7.1339Z" fill={color}/>
      <path d="M15.75 17.625C15.4739 17.625 15.25 17.4304 15.25 17.1902L15.25 6.05981C15.25 5.81969 15.4739 5.62503 15.75 5.62503C16.0261 5.62503 16.25 5.81969 16.25 6.05981L16.25 17.1902C16.25 17.4304 16.0261 17.625 15.75 17.625Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SlideLastOutlineIcon)
